import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Link } from '@common/general-ui/link/link.component';
import Collapse from 'antd/lib/collapse';
import React, { ReactNode, useState } from 'react';
import { css } from 'twin.macro';
const { Panel } = Collapse;
interface IProps {
    className?: string;
    label: ReactNode;
    children: ReactNode;
    icon?: boolean;
}

export const SimpleCollapse = ({ label, className, children, icon }: IProps): JSX.Element => {
    const [expanded, setExpanded] = useState(false);

    return (
        <Collapse
            className={className}
            onChange={(): void => setExpanded((p) => !p)}
            css={styles.root}
            ghost
            expandIconPosition="right"
            expandIcon={(): JSX.Element => <></>}
        >
            <Panel
                header={
                    <Link name="link">
                        {label}{' '}
                        {icon && (
                        expanded ? <UpOutlined tw="top-1 absolute ml-1" /> : <DownOutlined tw="top-1 ml-1 absolute" />
                        )}
                    </Link>
                }
                key="1"
            >
                {children}
            </Panel>
        </Collapse>
    );
};

const styles = {
    root: css`
        && .ant-collapse-item {
            padding: 0px;
        }
        && .ant-collapse-header {
            padding: 0px;
            background-color: transparent;
        }
        && .ant-collapse-content-box {
            padding: 0px;
        }

        && .ant-collapse-arrow {
            display: none;
        }
    `,
};
